import * as B from '@blueprintjs/core';
import classnames from 'classnames';
import React from 'react';

import {LegendUIProvider} from 'app/components/DeclarativeMap/LegendUIContext';
import DraggableMapOverlayDialog from 'app/components/MapOverlayDialog/DraggableMapOverlayDialog';

import {useGrid} from './GridContext';
import {gridPanelLeft} from './panelLayout';
import cs from './styles.module.scss';
import {Size} from './types';
import {MapInteractionTool} from '../view';

interface Props {
  isSidebarExpanded: boolean;
  activeMapInteractionTool: MapInteractionTool | null;
}

const SIZES: {value: Size; label: string; squarePx: number}[] = [
  {value: 'fine', label: 'Fine', squarePx: 12},
  {value: 'medium', label: 'Medium', squarePx: 20},
  {value: 'coarse', label: 'Coarse', squarePx: 28},
];

const GridSizePicker: React.FunctionComponent<Props> = ({
  isSidebarExpanded,
  activeMapInteractionTool,
}) => {
  const {setIsEnabled, gridSize, setGridSize, confirmGridSize} = useGrid();

  const [isCollapsed, setIsCollapsed] = React.useState(false);

  const left = gridPanelLeft(isSidebarExpanded, activeMapInteractionTool);

  return (
    <LegendUIProvider isLegendCollapsed={isCollapsed} setIsLegendCollapsed={setIsCollapsed}>
      <DraggableMapOverlayDialog
        title="Grid review"
        initialPosition={{top: 10, left}}
        onClose={() => setIsEnabled(false)}
      >
        <div className={cs.sizePickerContent}>
          <p>The grid review tool lets you create a grid and monitor your property one cell at a time. Get started by defining how big you want each cell to be.</p>
          <div className={cs.sizePickerButtons}>
            {SIZES.map(({value, label, squarePx}) => {
              const isSelected = gridSize === value;
              return (
                <button
                  key={value}
                  type="button"
                  className={classnames(cs.sizePickerButton, {
                    [cs.sizePickerButtonSelected]: isSelected,
                  })}
                  onClick={() => setGridSize(value)}
                >
                  <div
                    className={cs.sizePickerSquare}
                    style={{width: squarePx, height: squarePx}}
                  />
                  <span className={cs.sizePickerLabel}>{label}</span>
                </button>
              );
            })}
          </div>
          <B.Button
            fill
            intent={B.Intent.PRIMARY}
            text="Create grid"
            disabled={gridSize === null}
            onClick={confirmGridSize}
          />
        </div>
      </DraggableMapOverlayDialog>
    </LegendUIProvider>
  );
};

export default GridSizePicker;
